/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

window.Vue = require('vue')
import Cookies from 'js-cookie'
// Vuetify a la carte (#58). `vuetify/lib` + the VuetifyLoaderPlugin in
// webpack.mix.js: each .vue file gets imports for exactly the v-* components
// its template uses, and each component brings its own styles. Before, the
// whole library and vuetify.min.css (every component's CSS) went into app.js
// for every screen. The base styles (reset, theme, typography) still come
// from vuetify/lib itself.
import Vuetify from 'vuetify/lib'
// Directives are NOT auto-imported from templates: register every one a
// template uses (`grep -rE "v-(intersect|ripple|click-outside|resize|scroll|
// touch|mutate)" resources/js`). An unregistered directive fails silently.
import { Intersect } from 'vuetify/lib/directives'
import '../../design-system/tokens/tokens.css'
import { vuetifyThemes } from '../../design-system/tokens/vuetify-theme.js'
import store from './store/index.js'
import i18n from './plugins/i18n.js'
Vue.use(Vuetify, { directives: { Intersect } })

// One chunk per screen (#58). Blade decides which of the four renders, so a
// page only ever needs one of them — but with `require` all four (and every
// Vuetify component any of them uses) shipped in app.js to every visitor,
// including the customer opening a public link on a phone. Each import is
// fetched only when its tag is in the page; app.js keeps Vue, Vuetify's core,
// the store and i18n. Chunk names are stable (webpackChunkName) and the file
// carries the [chunkhash] — see webpack.mix.js and knowledge/ops/docker.md.
Vue.component('login-app', () =>
  import(/* webpackChunkName: "screen-login" */ './views/LoginApp.vue')
)
Vue.component('catalogo-app', () =>
  import(/* webpackChunkName: "screen-catalogo" */ './views/CatalogoApp.vue')
)
Vue.component('admin-app', () =>
  import(/* webpackChunkName: "screen-admin" */ './views/AdminApp.vue')
)
Vue.component('catalogo-publico-app', () =>
  import(
    /* webpackChunkName: "screen-catalogo-publico" */ './views/CatalogoPublicoApp.vue'
  )
)
Vue.prototype.$eventBus = new Vue()

const isDarkTheme = Cookies.get('theme') === 'dark'

const app = new Vue({
  el: '#app',
  store,
  i18n,
  vuetify: new Vuetify({
    theme: {
      dark: isDarkTheme,
      disable: false,
      options: { customProperties: true },
      themes: vuetifyThemes,
    },
    icons: {
      iconfont: 'mdi',
    },
  }),
})
